// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"8326a91a","513":"b7ae37db","703":"b8a80965","787":"168ef1fa"}[chunkId] + ".chunk.js";
};